import { InjectionToken } from '@angular/core';

export const PAYMENT_AUX_BASE_PATH = new InjectionToken<string>('PAYMENT_AUX_BASE_PATH');
export const COLLECTION_FORMATS = {
    'csv': ',',
    'tsv': '   ',
    'ssv': ' ',
    'pipes': '|'
}
